import { setGlobalContext } from '@modern-js/runtime/context';
let appConfig;
let appInit;
let layoutApp;

import { routes } from './routes';

setGlobalContext({
  layoutApp,
  routes,
  appInit,
  appConfig,
});